import { Nullish } from '@payaca/utilities/types';

export type WithChildren<T> = T & { children: WithChildren<T>[] };

export const unflattenFolders = <
  T extends
    | { id: string; parentId?: Nullish<string> }
    | { id: number; parentId?: Nullish<number> },
>(
  folders: T[],
  { ignoreRoot }: { ignoreRoot?: boolean } = {}
): Array<WithChildren<T>> => {
  const folderMap: Map<string | number, WithChildren<T>> = new Map(
    folders.map((folder) => [folder.id, { ...folder, children: [] }])
  );
  const rootFolders: WithChildren<T>[] = [];

  folders.forEach((folder) => {
    const folderWithChildren = folderMap.get(folder.id);

    if (!folderWithChildren) {
      return;
    }

    if (folder.parentId && folderMap.has(folder.parentId)) {
      const parent = folderMap.get(folder.parentId);
      if (parent) {
        parent.children.push(folderWithChildren);
      }
    } else {
      rootFolders.push(folderWithChildren);
    }
  });

  if (ignoreRoot) {
    return rootFolders[0]?.children || [];
  }

  return rootFolders;
};
